module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAASFBMVEVHcEy+vr6/v7++vr6+vr6+vr7ExMS+vr6+vr7AwMC+vr6+vr6+vr7AwMDCwsK/v7++vr6+vr6+vr7ExMS+vr6/v7++vr7ExMSrnx4VAAAAGHRSTlMA/xxrttkam/xO8vqqWiYMbv2uI/518w2prMnqAAAAv0lEQVR4Ad1UAxLEQBC8jtYbJ/9/6Tm20cXpGutxXwDnM/hiusG5asgw3eB0NWxo0KDubWCYlg3YlmmMUncIxR+UOMP6jENIpV1XKynA2ZC+5yMIMyEM4HsD/iM/Lsux77Pe/Dky/cwCvK8OgqBOBSA9/aQirHOhoN3dNSGbpITZaWBBNUkFq9PAhm6SGnanQQK3SbpIphmkSKanNL3o6W2dPrjpqzFp+brB/GnrPf2App/o5CeQvZkkyd7M/ngBUHoHoLjsuC8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/a0_key@2x.png
// module id = +bbC
// module chunks = 1